import { ServicesEndpoints } from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import { useAuthApiGetSingleFetch } from '@/dataAccess/rest/apiHooks';

export const useAvailableServicesData = () => {
  return useAuthApiGetSingleFetch<string[]>({
    baseApiRoute: API_NAMES.servicesApi,
    route: ServicesEndpoints.getPodsNames,
    cacheKeys: [CACHE_KEYS.podsNames],
    refetchOnWindowFocus: false,
  });
};
